import resolveModule from "components/GuidePreview/utils/resolveModule";
import { GuideTemplateForPreviewFragment } from "generated/schemaTypes";
import { find, map } from "lodash";
import { useMemo } from "react";

import useExampleCandidateModuleContext from "../context/useExampleCandidateModuleContext";

const useResolvedGuideTemplateStagesWithExampleContext = (
  guideTemplate?: GuideTemplateForPreviewFragment
) => {
  const { context, loading } = useExampleCandidateModuleContext({
    stages: guideTemplate?.guideTemplateStages ?? [],
  });

  const stages = useMemo(() => {
    if (!guideTemplate || !context) {
      return null;
    }

    // Don't show stages for preview if they don't have a ContentTemplate
    return guideTemplate.guideTemplateStages.map((guideTemplateStage) => {
      const stageContext = find(context.stages, {
        id: guideTemplateStage.id,
      });

      return {
        id: guideTemplateStage.id,
        title: guideTemplateStage.name,
        description: guideTemplateStage.description,
        position: guideTemplateStage.position,
        needsFeedback: false,
        resolvedModules: map(
          guideTemplateStage.contentTemplate?.modulesInflated,
          (module) => resolveModule(module, context, stageContext)
        ),
      };
    });
  }, [guideTemplate, context]);

  return {
    stages,
    loading,
  };
};

export default useResolvedGuideTemplateStagesWithExampleContext;
